import { render, staticRenderFns } from "./CameraSchool.vue?vue&type=template&id=3f225104"
import script from "./CameraSchool.vue?vue&type=script&lang=js"
export * from "./CameraSchool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f225104')) {
      api.createRecord('3f225104', component.options)
    } else {
      api.reload('3f225104', component.options)
    }
    module.hot.accept("./CameraSchool.vue?vue&type=template&id=3f225104", function () {
      api.rerender('3f225104', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/camera/CameraSchool.vue"
export default component.exports